import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import DialogContentText from "@mui/material/DialogContentText";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";

interface GeneratedPasswordDialogProps {
  open: boolean;
  login: string;
  password: string;
  onClose: () => void;
}

// Shown once after user creation or password reset; the generated password is
// returned by the backend exactly once and is not retrievable afterwards.
export function GeneratedPasswordDialog({ open, login, password, onClose }: GeneratedPasswordDialogProps) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Пароль сгенерирован</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>
          Сохраните пароль и передайте его пользователю. Пароль показывается только один раз.
        </DialogContentText>
        <Box display="flex" flexDirection="column" gap={2}>
          <TextField label="Логин" value={login} slotProps={{ input: { readOnly: true } }} fullWidth />
          <TextField label="Пароль" value={password} slotProps={{ input: { readOnly: true } }} fullWidth />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained">
          Готово
        </Button>
      </DialogActions>
    </Dialog>
  );
}
